import "slick-carousel";
(function($) {
  "use strict";
  $(function() {
    $(".carousel-main").slick({
      infinite: true,
      dots: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      autoplayHoverPause: true,
      fade: true,
      swipeToSlide: true,
      prevArrow:
        '<span><svg  class="svg-inline--fa fa-w-8 slick-prev " width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3496 29.9985C13.5161 29.9985 13.6825 29.9237 13.8099 29.7756C14.0634 29.478 14.0634 28.9941 13.8099 28.6965L2.5695 15.4994L13.8099 2.30238C14.0634 2.00474 14.0634 1.52088 13.8099 1.22323C13.5564 0.925589 13.1442 0.925589 12.8907 1.22323L1.19013 14.9606C0.936622 15.2583 0.936622 15.7421 1.19013 16.0398L12.8907 29.7771C13.0181 29.9267 13.1845 30 13.3509 30L13.3496 29.9985Z" fill="white" stroke="white" stroke-width="2"/></svg></span>',
      nextArrow:
        '<span><svg class="svg-inline--fa  fa-w-8 slick-next "  width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.65036 1.00153C2.48395 1.00153 2.31754 1.07632 2.19014 1.22438C1.93662 1.52202 1.93662 2.00588 2.19014 2.30353L13.4305 15.5006L2.19014 28.6976C1.93662 28.9953 1.93662 29.4791 2.19014 29.7768C2.44365 30.0744 2.85577 30.0744 3.10928 29.7768L14.8099 16.0394C15.0634 15.7417 15.0634 15.2579 14.8099 14.9602L3.10928 1.22285C2.98188 1.07327 2.81547 1 2.64906 1L2.65036 1.00153Z" fill="white" stroke="white" stroke-width="2"/></svg></span>',
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            arrows: false
          }
        }
      ]
    });

    // $(".carousel-services").slick({
    //   infinite: true,
    //   dots: true,
    //   arrows: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   autoplaySpeed: 5000,
    //   autoplayHoverPause: true
    // });

    // $(".carousel-news").slick({
    //   infinite: true,
    //   arrows: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   fade: true,
    //   swipeToSlide: true,
    //   autoplay: true,
    //   autoplaySpeed: 7000,
    //   autoplayHoverPause: true
    // });
  });
})(jQuery);
